import { render } from "./Refresh.svg?vue&type=template&id=28b513e5"
const script = {}
script.render = render

export default script